import React, { useEffect, useState, useCallback } from "react";
import { Redirect } from "react-router-dom";
import { Card, CardBody, Text } from "@patternfly/react-core";
import {
  Table,
  TableHeader,
  TableBody,
  TableVariant,
  cellWidth,
} from "@patternfly/react-table";
import DeleteConfirmationModal from "../general/DeleteConfirmationModal";
import TextEllipsis from "../general/TextEllipsis";
import _flattern from "lodash/flatten";
import "../../css/index.css";

export default (props) => {
  const users = props.users;

  const headers = [
    { title: "ID" },
    { title: "Kerberos ID" },
    { title: "First Name" },
    { title: "Last Name" },
    { title: "Email" },
    { title: "Edit Product", transforms: [cellWidth(30)] },
    { title: "Add/Remove Product" },
    { title: "User Management" },
  ];
  const userRows = users.map((user) => ({
    cells: [
      user.id,
      {
        title: <Text className={"userKerberos"}>{user.kerberos}</Text>,
      },
      user.first_name,
      user.last_name,
      user.email,
      {
        title: (
          <TextEllipsis text={user.user_products} maxlength="66"></TextEllipsis>
        ),
      },
      user.manage_product ? "Yes" : "No",
      user.manage_user ? "Yes" : "No",
    ],
  }));

  const [rows, setRows] = useState(userRows);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState({});
  const [userToEdit, setUserToEdit] = useState({});
  const [isRedirectUser, setIsRedirectUser] = useState(false);

  const renderRows = useCallback(() => {
    let renderedRows = [];
    props.users.forEach((user, index) => {
      renderedRows.push(userToRow(user, index));
    });

    return _flattern(renderedRows);
  }, [props]);

  useEffect(() => {
    // if props.users changed, re-build the rows
    setRows(renderRows);
  }, [users, renderRows]);

  function userToRow(user, index) {
    return [
      {
        cells: [
          user.id,
          {
            title: <Text className={"userKerberos"}>{user.kerberos}</Text>,
          },
          user.first_name,
          user.last_name,
          user.email,
          {
            title: (
              <TextEllipsis
                text={user.user_products}
                maxlength="66"
              ></TextEllipsis>
            ),
          },
          user.manage_product ? "Yes" : "No",
          user.manage_user ? "Yes" : "No",
        ],
      },
    ];
  }

  function onModelOpen(event) {
    setIsModalOpen(true);
  }

  function handleModalToggle() {
    setIsModalOpen(!isModalOpen);
  }

  function actionResolver(rowData, { rowIndex }) {
    return [
      {
        title: "Edit this User",
        onClick: (event, rowId, rowData, extra) => {
          setUserToEdit(users[rowId]);
          setIsRedirectUser(true);
        },
      },
      {
        title: "Remove this User",
        onClick: (event, rowId, rowData, extra) => {
          onModelOpen();
          setUserToDelete(users[rowId]);
        },
      },
    ];
  }

  return (
    <>
      {isRedirectUser ? <Redirect to={`/user/${userToEdit.id}/edit`} /> : null}
      <Table
        aria-label="user-list-table"
        variant={TableVariant.compact}
        cells={headers}
        rows={rows}
        actionResolver={actionResolver}
      //onSort={onSort}
      //sortBy={sortBy}
      >
        <TableHeader />
        <TableBody rowKey="cells" />
      </Table>
      <Card>
        <CardBody>
          <br></br>
        </CardBody>
      </Card>
      <DeleteConfirmationModal
        name={`${userToDelete.kerberos}`}
        userid={`${userToDelete.id}`}
        type={"user"}
        isModalOpen={isModalOpen}
        handleModalToggle={handleModalToggle}
      />
    </>
  );
};
